import Vue from 'vue'
import Router from 'vue-router'
import WelcomeView from '@/components/WelcomeView'
import CalendarView from '@/components/CalendarView'
import VisitView from '@/components/VisitView'
import RefreshVisitView from '@/components/RefreshVisitView'
import InboxView from '@/components/InboxView'
import OutboxView from '@/components/OutboxView'
import ChangesView from '@/components/ChangesView'
import ChangeView from '@/components/ChangeView'
import SurveysView from '@/components/SurveysView'
import MessageView from '@/components/MessageView'
import CheckoutView from '@/components/CheckoutView'
//import SyncView from '@/components/SyncView'
import LoginView from '@/components/LoginView'

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '/',
      name: 'welcome',
      component: WelcomeView,
      meta: {
        auth: true
      }
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: CalendarView,
      meta: {
        auth: true
      }
    },
    {
      path: '/day/:d',
      name: 'day',
      component: CalendarView,
      meta: {
        auth: true
      }
    },
    {
      path: '/visits/:id',
      name: 'detail',
      component: VisitView,
      meta: {
        auth: true
      }
    },
    {
      path: '/refresh/:id',
      name: 'refresh',
      component: RefreshVisitView,
      meta: {
        auth: true
      }
    },
    {
      path: '/inbox',
      name: 'inbox',
      component: InboxView,
      meta: {
        auth: true
      }
    },
    {
      path: '/messages/:id',
      name: 'message',
      component: MessageView,
      meta: {
        auth: true
      }
    },
    {
      path: '/outbox',
      name: 'outbox',
      component: OutboxView,
      meta: {
        auth: true
      }
    },
    {
      path: '/changes',
      name: 'changes',
      component: ChangesView,
      meta: {
        auth: true
      }
    },
    {
      path: '/changes/new',
      name: 'changes_new',
      component: ChangeView,
      meta: {
        auth: true
      }
    },
    {
      path: '/surveys',
      name: 'surveys',
      component: SurveysView,
      meta: {
        auth: true
      }
    },
    {
      path: '/visits/:id/checkout',
      name: 'checkout',
      component: CheckoutView,
      meta: {
        auth: true
      }
    },
    //{
    //  path: '/sync',
    //  name: 'sync',
    //  component: SyncView
    //},
    {
      path: '/login',
      name: 'login',
      component: LoginView
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    //Firebase.auth().onAuthStateChanged(function(user) {
      if (!localStorage.getItem('currentUser') || localStorage.getItem('currentUser') == 'null') {
        next({
          path: '/login'
        })
      } else {
        next()
      }
    //})
  } else {
    next()
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js